import React from 'react';
import css from './moneyBackGuarantee.module.css';

const MoneyBackGuarantee = ({}) => (
    <div className={css.root}>
        <img src="/static/badges/money-back-guarantee.png" alt="Money Back Guarantee" />
    </div>
);

export default MoneyBackGuarantee;